import moment from 'moment';

function getWidgetNameByType(type) {
  if (type === 'RESERVATION_REQUEST') return 'Reservation Request';
  if (type === 'GUEST_LIST') return 'Guestlist';
  if (type === 'INVENTORY_MAP') return 'Inventory Map';
  if (type === 'INVENTORY_LIST') return 'Inventory List';
  if (type === 'EVENT_LIST') return 'Event List';
  if (type === 'EVENT_CALENDAR') return 'Event Calendar';
  if (type === 'EVENT_CAROUSEL') return 'Event Carousel';
  return '';
}

function SettingsVenueWidgetCtrl($scope, $state, $stateParams, sdkVenueService, sdkEventService, dateUtilsService) {
  $scope.venuePromise = sdkVenueService.readById($stateParams.venueId);

  const vm = this;

  vm.widgetType = $stateParams.type;
  vm.widgetName = getWidgetNameByType(vm.widgetType);

  $scope.venuePromise
    .then(venue => {
      vm.venue = venue;

      return sdkEventService.listByVenueId(vm.venue.id, {
        start: dateUtilsService.toUTCTimestampWithoutTime(moment.utc()),
        end: dateUtilsService.toUTCTimestampWithoutTime(moment.utc().add('month', 1))
      });
    })
    .then(events => {
      vm.events = events;
    });
}

SettingsVenueWidgetCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'jsSdk.venue',
  'jsSdk.event',
  'dateUtilsService'
];

export default SettingsVenueWidgetCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsVenueWidget/settingsVenueWidgetCtrl.js